import { createContext, useContext } from 'react'
import type { User } from '@supabase/supabase-js'

export type PlatformSession = { user: User | null; sessionVersion: number; loading: boolean; sessionError: string; signIn: (email: string, password: string) => Promise<void>; signOut: () => Promise<void> }
export const PlatformAuthContext = createContext<PlatformSession | null>(null)

export function usePlatformAuth() {
  const context = useContext(PlatformAuthContext)
  if (!context) throw new Error('Platform session unavailable')
  return context
}
